<template>
  <div class="component-content configuration-colour">
    <div class="component-content-scroll">
    <div class="component-content-title mb-4">
      Select your colour details
    </div>
    <div
      class="xs-text uppercase xs-content mb-3"
      v-if="this.results.colour.type == null"
    >
      There are three ways to configure the colour scheme of your passoni
    </div>

    <option-list
      :options="getOptions()"
      :inputName="'colourType'"
      :target="this.results.colour.type"
      v-on:target-updated="updateData"
      v-if="this.results.colour.type == null"
    ></option-list>

    <component
      v-bind:is="getContent"
      :results="results"
      :primaryColor="this.results.colour.primaryColor"
      :secondaryColor="this.results.colour.secondaryColor"
      :colors="colors"
      :componentsConfig="componentsConfig"
      :currentTab="currentTab"
      :bikeId="bikeId"
      v-on:set-primary-color="setPrimaryColor"
      v-on:set-secondary-color="setSecondaryColor"
      v-on:current-substep="updateSubstep"
    ></component>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";

import officialColorsTab from "./sub-components/color-official-colors.vue";
import bespokeColorsTab from "./sub-components/color-bespoke-colors.vue";
import customColorsTab from "./sub-components/color-custom-colors.vue";

import colorPicker from "./sub-components/color-picker.vue";
import {
  isOt01BrushedColor,
  supportsSecondaryColor,
} from "../../../utils/colourRules";

Vue.component("color-picker", colorPicker);

Vue.component("color-official-colors", officialColorsTab);
Vue.component("color-bespoke-colors", bespokeColorsTab);
Vue.component("color-custom-colors", customColorsTab);

export default {
  name: "configuration-colour",
  data() {
    return {
      subSteps: [
        {
          name: "color-officials",
          template: "color-official-colors",
        },
        {
          name: "color-bespoke",
          template: "color-bespoke-colors",
        },
        {
          name: "color-custom",
          template: "color-custom-colors",
        },
      ],
      currentTab: 0,
    };
  },
  components: {
    OptionList,
  },
  computed: {
    bikeId: function () {
      return this.bikeConfiguration && this.bikeConfiguration[0]
        ? this.bikeConfiguration[0].bike_id
        : null;
    },
    primaryColorHasSurcharge: function () {
      return Number(this.results.colour.primaryColorPrice || 0) > 0;
    },
    primaryColorIsOt01Brushed: function () {
      return isOt01BrushedColor(this.bikeId, this.results.colour.primaryColor);
    },
    secondaryColorLocked: function () {
      return this.primaryColorHasSurcharge || this.primaryColorIsOt01Brushed;
    },
    hasSecondaryColorStep: function () {
      return supportsSecondaryColor(this.bikeId) && !this.secondaryColorLocked;
    },
    totalTabs: function () {
      return this.hasSecondaryColorStep ? 2 : 1;
    },
    fullCustomPaintworkPrice: function () {
      if (!this.components || typeof this.components !== "object") {
        return 0;
      }

      if (this.components.fcpColorPrice != null) {
        return Number(this.components.fcpColorPrice) || 0;
      }

      for (const value of Object.values(this.components)) {
        if (!Array.isArray(value) || !Array.isArray(value[0])) {
          continue;
        }

        const match = value[0].find(
          (item) => item && item.sku && String(item.sku).toUpperCase() === "FCP-COLOR"
        );

        if (match && match.price != null) {
          return Number(match.price) || 0;
        }
      }

      return 0;
    },
    getContent: function () {
      if (this.results.colour.type != null) {
        if (this.results.colour.type.id == 991) {
          return "color-official-colors";
        }
        if (this.results.colour.type.id == 992) {
          return "color-bespoke-colors";
        }
        if (this.results.colour.type.id == 993) {
          return "color-custom-colors";
        }
      }
      return null;
    },
  },
  props: [
    "configuratorSteps",
    "results",
    "currentStep",
    "colors",
    "bikeConfiguration",
    "components",
    "componentsConfig",
  ],
  watch: {
    totalTabs: function (newTotalTabs) {
      if (this.currentTab > newTotalTabs - 1) {
        this.currentTab = newTotalTabs - 1;
      }
    },
  },
  methods: {
    getOptions: function () {
      return [
        {
          id: 991,
          name: "Official Passoni colours",
          price: 0,
          description: "",
        },
        // {
        //   id: 992,
        //   name: "Bespoke colours",
        //   price: 500,
        //   description: "",
        // },
        {
          id: 993,
          name: "Full custom paintwork",
          price: this.fullCustomPaintworkPrice,
          description: "",
        },
      ];
    },
    goNext: function () {
      if (this.results.colour.type == null) {
        this.$emit("set-error", "Select a color type");
      } else {
        if (
          this.results.colour.type.id == 991 ||
          this.results.colour.type.id == 992
        ) {
          if (this.results.colour.primaryColor==null) {
            this.$emit("set-error", "Select a color primary colour");
            return false;
          }

          // If the primary color is monocolor-only, secondary is locked and
          // automatically aligned to primary: skip the secondary step.
          if (this.secondaryColorLocked) {
            this.$emit("go-next");
            return false;
          }

          if (this.hasSecondaryColorStep){
            if (this.results.colour.secondaryColor==null && this.currentTab == 1) {
              this.$emit("set-error", "Select a color secondary colour");
              return false;
            }
          }

          if (this.currentTab<this.totalTabs-1) {
            this.currentTab++;
          } else {
            this.$emit("go-next");
          }



        } else {
          this.$emit("go-next");
        }
      }
    },
    goBack: function () {

      if (this.currentTab>0) {
        this.currentTab--;
        return false;
      }

      if (this.officialSubStep == 1 && this.hasSecondaryColorStep){
        this.officialSubStep--;
        return false;
      }

      if (this.results.colour.type == null) {
        this.$emit("go-back");
      } else {
        this.$emit("set-colour-type", null);
      }

    },
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
    updateData: function (e) {
      this.$emit("set-colour-type", e);
    },
    updateSubstep: function(e){
      this.currentTab = e;
    }
  },
};
</script>

<style lang="scss" scoped>
.configuration-colour {
}
</style>
